unit UITypes;

interface

type
  TFontName = type string;

implementation

end.